exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  padding-top: 70px;\n}\nfooter {\n  padding: 30px 0;\n}\n\n.right-bar {\n  top: 4rem;\n  position: -webkit-sticky;\n  position: sticky;\n  max-height: calc(100vh - 4rem);\n  overflow-y: auto;\n  -ms-flex-order: 2;\n      order: 2;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  font-size: .875rem;\n}\n\n.section-nav {\n  padding-left: 0;\n  border-left: 1px solid #eee;\n}\n\n.toc-entry a {\n  display: block;\n  padding: .125rem 1.5rem;\n  color: #99979c;\n}\n\n.toc-entry a:hover {\n  color: blue;\n  text-decoration: none;\n}\n\n.potrait {\n  width: 100%;\n}\n\n.blog-header {\n  padding: 50px;\n  border-bottom: .05rem solid #eee;\n}\n\n.blog-sidebar {\n  padding: 30px 0px 0px 20px;\n}\n\n.card {\n  width: 45%;\n  margin: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/cv/cv.component.css
// module id = 154
// module chunks = 1